import { useState } from 'react'

import CameraParallax from './components/CameraParallax.jsx'
import EnvironmentTransitioner from './components/EnvironmentTransitioner.jsx'
import NavPanel from './components/NavPanel.jsx'
import MainPanel from './components/MainPanel.jsx'
import DescriptionPanel from './components/DescriptionPanel.jsx'
import SocialsPanel from './components/SocialsPanel.jsx'

import { pages } from './data.js'

export default function Experience({ videoRef }) {
  const [pageIndex, setPageIndex] = useState(0)

  return (
    <>
      <CameraParallax />
      <EnvironmentTransitioner pages={pages} pageIndex={pageIndex} />

      <group rotation={[0, Math.PI * 0.1, 0]} position={[-1.8, 0, 0.1]}>
        <NavPanel pages={pages} pageIndex={pageIndex} setPageIndex={setPageIndex}></NavPanel>
      </group>
      <group rotation={[0, 0, 0]} position={[0, 0, 0]}>
        <MainPanel pages={pages} pageIndex={pageIndex} videoRef={videoRef}></MainPanel>
      </group>
      <group rotation={[0, -Math.PI * 0.1, 0]} position={[2.2, 0, 0.225]}>
        <DescriptionPanel pages={pages} pageIndex={pageIndex} />
      </group>
      <group rotation={[0, 0, 0]} position={[0, -1, 0]}>
        <SocialsPanel />
      </group>
    </>
  )
}
